module.exports = __webpack_public_path__ + "img/2.69855591.jpg";